<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    max-width="90%"
    min-height="60%"
    height="auto"
  >
    <v-card>
      <v-toolbar color="primary">
        <v-card-title>
          <span class="text-h5">{{
            $t("strings.dialog-preview-mashup-preview")
          }}</span>
        </v-card-title>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text class="d-flex align-center">
        <v-row
          dense
          justify="space-around"
          align="center"
          class="align-self-stretch"
        >
          <v-col cols="5" class="mx-auto align-self-stretch">
            <v-sheet
              :border="inputs.lenght > 0 ? true : false"
              rounded
              height="100%"
              width="100%"
              class="mx-auto pa-2"
            >
              <template v-for="input in inputs" :key="input.id">
                <v-text-field
                  :label="`${input.userData.label || input.id} [${input.id}]`"
                  :model-value="getInputValue(input)"
                  @update:model-value="(val) => setInputValue(input, val)"
                  variant="outlined"
                  :hint="
                    input.userData.isConstant == true
                      ? $t('strings.dialog-preview-used-like-constant')
                      : ''
                  "
                  :persistent-hint="
                    input.userData.isConstant == true ? true : false
                  "
                  :class="input.userData.isConstant == true ? 'mb-4' : ''"
                  class="custom-hint-style"
                  :readonly="
                    input.data.subCategory == 'fileEntry' ? true : false
                  "
                ></v-text-field>
              </template>
            </v-sheet>
          </v-col>
          <v-col
            cols="2"
            class="mx-auto align-self-stretch d-flex justify-center align-center"
          >
            <v-tooltip
              :text="$t('strings.dialog-preview-run-preview')"
              location="top"
            >
              <template v-slot:activator="{ props }">
                <v-btn
                  v-bind="props"
                  density="default"
                  color="secondary"
                  icon="mdi-play"
                  @click="runPreview"
                >
                </v-btn>
              </template>
            </v-tooltip>
          </v-col>
          <v-col cols="5" class="mx-auto align-self-stretch">
            <v-card
              variant="outlined"
              rounded
              class="mx-auto pa-2"
              height="100%"
              width="100%"
            >
              <v-toolbar>
                <div class="px-2">
                  <div class="text-primary">{{ targetLabel }}</div>
                  <div class="font-weight-medium">{{ targetId }}</div>
                </div>
                <template v-slot:append>
                  <v-tooltip
                    v-if="reveal"
                    :text="$t('strings.dialog-preview-view-tree')"
                    location="top"
                  >
                    <template v-slot:activator="{ props }">
                      <v-btn
                        icon="mdi-file-tree"
                        size="x-small"
                        @click="reveal = false"
                        v-bind="props"
                      >
                      </v-btn>
                    </template>
                  </v-tooltip>
                  <v-tooltip
                    v-else
                    :text="$t('strings.dialog-preview-view-raw')"
                    location="top"
                  >
                    <template v-slot:activator="{ props }">
                      <v-btn
                        icon="mdi-raw"
                        density="compact"
                        @click="reveal = true"
                        v-bind="props"
                      >
                      </v-btn>
                    </template>
                  </v-tooltip>
                  <v-divider
                    class="mx-3"
                    thickness="2"
                    vertical
                    inset
                  ></v-divider>
                  <v-tooltip
                    :text="$t('strings.dialog-preview-copy-clipboard')"
                    location="top"
                  >
                    <template v-slot:activator="{ props }">
                      <v-btn
                        icon="mdi-content-copy"
                        size="x-small"
                        @click="copyRaw"
                        v-bind="props"
                      >
                      </v-btn>
                    </template>
                  </v-tooltip>
                </template>
              </v-toolbar>
              <v-divider></v-divider>
              <v-card-text>
                <SimpleTreeView
                  :inputs="transformInputs(previewResult)"
                  :ondragActivation="false"
                />
              </v-card-text>
              <v-expand-transition>
                <v-card
                  v-if="reveal"
                  class="v-card--reveal ml-n2 pa-2"
                  variant="flat"
                  height="calc(100% - 74px)"
                  width="100%"
                >
                    <v-textarea
                      v-model="previewResultString"
                      class="custom-text-area"
                      :label="$t('labels.raw')"
                      hide-details
                      :readonly="true"
                      variant="plain"
                      bg-color="grey-lighten-3"
                      no-resize
                    ></v-textarea>
                </v-card>
              </v-expand-transition>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" variant="text" @click="dialog = false">
          {{ $t("labels.close") }}
        </v-btn>
        <v-btn
          v-if="custom"
          color="secondary"
          variant="text"
          @click="returnPreview"
          :disabled="preview ? false : true"
        >
          {{ $t("labels.save") }}
        </v-btn>
      </v-card-actions>
      <v-overlay
        v-model="loading"
        contained
        class="align-center justify-center"
        persistent
      >
        <v-progress-circular
          indeterminate
          color="primary"
          size="64"
        ></v-progress-circular>
      </v-overlay>
    </v-card>
  </v-dialog>
</template>
<script>
// import axios from "axios";
import { preview } from "../mixins/VueFlowEditor.js";
import SimpleTreeView from "./blocks/static/SimpleTreeView.vue";
export default {
  name: "DialogPreview",
  props: [
    "showDialogPreview",
    "targetLabel",
    "targetId",
    "nodes",
    "apiDraw",
    "custom",
    "canvaNodes",
  ],
  components: {
    SimpleTreeView,
  },
  data() {
    return {
      settings: { showNodeSettings: false },
      inputs: {},
      preview: "",
      loading: false,
      reveal: false,
      showSnackbar: false,
    };
  },
  computed: {
    dialog: {
      get() {
        return this.showDialogPreview;
      },
      set(value) {
        this.$emit("toggleDialogPreview", value);
      },
    },
    previewResultString() {
      const string = this.previewResult;
      return JSON.stringify(string, null, 2);
    },
    previewResult() {
      const result = this.preview ? this.preview?.result : {};
      return result;
    },
  },
  mounted() {
    this.inputs = JSON.parse(JSON.stringify(this.nodes));
    this.createInputsObject();
  },
  methods: {
    getInputValue(input) {
      if (input.data.subCategory === "fileEntry") {
        return input.userData.fileName || "";
      } else {
        return input.userData.defaultValue || "";
      }
    },
    setInputValue(input, val) {
      if (input.data.subCategory !== "fileEntry") {
        input.userData.defaultValue = val;
      }
    },
    copyRaw() {
      navigator.clipboard.writeText(
        JSON.stringify(this.previewResult, null, 2),
      );
    },
    createInputsObject() {
      let objInputs = {};
      this.inputs.forEach((object) => {
        if (object.userData && object.userData.defaultValue) {
          objInputs[object.id] = object.userData.defaultValue;
        }
      });
      return objInputs;
    },
    returnPreview() {
      this.$emit("updatePreview", this.targetId, this.previewResult);
      this.dialog = false;
    },
    //Calls Mashup Preview
    async runPreview() {
      const data = {
        inputs: this.createInputsObject(),
        target: this.targetId,
        draw: this.canvaNodes,
      };
      this.loading = true;
      try {
        this.preview = await preview(this.apiDraw, data);
        const snackbarPreview = this.manageSnackbarPreview(this.preview);
        this.showSnackbar = true;
        this.$emit(
          "setSnackbar",
          this.showSnackbar,
          snackbarPreview.text,
          snackbarPreview.color,
          -1,
        );
        this.$emit("debugExecution", this.preview);
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
      return null;
    },

    /*
     * THis method analyze debug response and arrange messages to show
     * in the snackbar for the user. It returns a long string with # symbols
     * that separate the multiple messages to show.
     */
    manageSnackbarPreview(preview) {
      const debug = preview.debug;
      let snackbar = { text: "", color: "error" };

      if (debug.errorCounter > 0 || debug.warningCounter > 0) {
        // Get the keys of the mainExec object
        const mainExecKeys = Object.keys(debug.mainExec);
        //Update nodes with errors found for each key
        for (const nodeId of mainExecKeys) {
          //Check if Node in Preview is in Error
          if (
            nodeId == this.targetId &&
            debug.mainExec[nodeId].errors.length > 0
          ) {
            snackbar.text += "strings.node-in-error" + "#";
          } else {
            //If Preview isn't global
            if (this.targetId != "output" && nodeId == this.targetId) {
              snackbar.text +=
                this.$t("strings.preview-node-no-error", {
                  value: this.targetId,
                }) +
                "#" +
                "strings.but" +
                "##";
              snackbar.color = "warning";
            }
          }
        }
        snackbar.text += "strings.preview-not-valid";
        return snackbar;
      } else {
        snackbar.text += this.$t("strings.preview-correct");
        snackbar.color = "success";
        return snackbar;
      }
    },

    transformInputs(inputs) {
      if (typeof inputs === "boolean") {
        return inputs.toString();
      }
      if (typeof inputs === "object" && inputs !== null) {
        // Transform boolean values into strings
        return Object.fromEntries(
          Object.entries(inputs).map(([key, value]) => [
            key,
            typeof value === "boolean" ? value.toString() : value,
          ]),
        );
      }
      return inputs;
    },
  },
};
</script>

<style scoped>
.custom-hint-style :deep(.v-input__details .v-messages .v-messages__message) {
  color: #c8004b !important;
}

.v-card--reveal {
  top: 74px;
  bottom: 0;
  opacity: 1 !important;
  position: absolute;
  display: flex;
  flex-direction: column;
}

.custom-text-area {
  flex: 1;
  min-height: 0;
  height: 100%;
}

.custom-text-area :deep(.v-input__control) {
  height: 100%;
}

.custom-text-area :deep(.v-field) {
  height: 100%;
}

.custom-text-area :deep(textarea) {
  font-size: 0.8em;
  height: 100% !important;
  overflow-y: auto;
  resize: none;
}
</style>
